import { AxiosRepo } from '@/helpers/interceptorsSetup';
import { CONSTANTS } from '@/constants/guide';
import { download } from '@/helpers/siteHelper';

const axiosInstance = AxiosRepo.getInstance();

export const actions = {
  getBreeds({ dispatch, commit, state }, payload) {
    return axiosInstance
      .get(
        `${CONSTANTS.APP.BASE_URL}/futalis/service/breeds/?q=${payload.query}&lb=0&l=30`+(payload.subBreeds===true ? '&s=1' : ''),
        { customUrl: true }
      )
      .then(response => {
        return {
          success: true,
          response: response
        };
      })
      .catch(error => {
        console.log(error);
        return false;
      });
  },
  updateData({ dispatch, commit, state }, payload) {
    return axiosInstance
      .post(`/ivs/Configurator/updateData`, payload)
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(error);
        return false;
      });
  },
  getIllnesses({ dispatch, commit, state }, payload) {
    return axiosInstance
      .post(`/ivs/Configurator/getIllnesses`, payload)
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(error);
        return false;
      });
  },
  getSpecialIllnesses({ dispatch, commit, state }) {
    return axiosInstance
      .get(`/ivs/Configurator/getSpecialIllnesses`)
      .then((response) => {
        commit('setSpecialIllnesses', response);
      })
      .catch((error) => {
        console.log(error);
        return false;
      });
  },
  getPetData({ dispatch, commit, state }, payload) {
    return axiosInstance
      .get(`/ivs/Configurator/getPetData?id=${payload}`)
      .then(response => {
        return response;
      });
  },
  getPetDetailedDescription({ dispatch, commit, state }, payload) {
    return axiosInstance
      .get(`/ivs/Configurator/getPetDetailedDescription?petId=${payload}`)
      .then(response => {
        return response;
      })
      .catch(error => {
        return error;
      });
  },
  savePet({ commit, state }, payload) {
    switch (payload.mode) {
      case CONSTANTS.CONFIGURATOR.MODES.EDIT_PET:
        payload.petData = { ...payload.petData, petId: payload.id };
        break;
      case CONSTANTS.CONFIGURATOR.MODES.ADD_PET_TO_CLIENT:
        payload.petData = { ...payload.petData, clientId: payload.id };
        break;
      case CONSTANTS.CONFIGURATOR.MODES.NEW_PET:
        payload.petData = { ...payload.petData, clientId: null };
        break;
    }
    return axiosInstance
      .post(`/ivs/Configurator/savePet`, payload.petData)
      .then(response => {
        return { success: true, data: response };
      })
      .catch(error => {
        return { success: false, message: error };
      });
  },
  getOrphanPets({ dispatch, commit, state }) {
    return axiosInstance
      .get(`/ivs/Configurator/getOrphanPets`)
      .then(response => {
        commit('setOrphanPets', response);
      })
      .catch(error => {
        console.log(error);
        return false;
      });
  },
  getRationRequirements({ dispatch, commit, state }, petId) {
    return axiosInstance
      .get(`/ivs/Configurator/getRationPrufenRequiredData?petId=${petId}`)
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(error);
        return false;
      });
  },
  getSupplementsElementsValues({ dispatch, commit, state }, payload) {
    return axiosInstance
      .post(`/ivs/Configurator/getSupplementsElementsValues`, payload)
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(error);
        return false;
      });
  },
  getFoodBookletData({ dispatch, commit, state }) {
    return axiosInstance
      .get(`/ivs/Configurator/getFoodBookletData`)
      .then(response => {
        commit('setFoodBookletData', response);
      })
      .catch(error => {
        console.log(error);
        return false;
      });
  },
  saveVetSupplement({ dispatch, commit, state }, form) {
    return axiosInstance
      .post(`/ivs/Configurator/saveVetSupplement`, form)
      .then(response => {
        const responseData = response;
        if (responseData !== undefined && responseData.success === true) {
          commit('setVetSupplements', responseData.extSupp);
          return responseData;
        }
        return { success: false, error: 'UNABLE TO SAVE' };
      })
      .catch(error => {
        return { success: false, error: error };
      });
  },
  saveColumnSettings({ dispatch, commit, state }, changedColumns) {
    return axiosInstance
      .post(`/ivs/Configurator/saveColumnSettings`, changedColumns)
      .then(response => {
        return response;
      })
      .catch(error => {
        console.log(error);
        return false;
      });
  },
  saveRation({ dispatch, commit, state }, payload) {
    return axiosInstance
      .post(`/ivs/Configurator/saveRation`, payload)
      .then(response => {
        return response;
      })
      .catch(error => {
        return { success: false, error: error };
      });
  },
  generateDocs({ dispatch, commit, state }, payload) {
    let endPoint = '';
    switch (payload.type) {
      case CONSTANTS.DOCS.TYPES.CLIENT_DOCS:
        endPoint = 'generateClientDocs';
        break;
      case CONSTANTS.DOCS.TYPES.PET_DOCS:
        endPoint = 'generatePetDocs';
    }
    delete payload.type;
    return axiosInstance
      .post(`/ivs/Configurator/${endPoint}`, payload, {
        responseType: 'arraybuffer'
      })
      .then(async response => {
        if (response.headers.get("Content-Type") === 'application/pdf') {
          let contentDisposition = response.headers.get("Content-disposition") || '';
          contentDisposition = contentDisposition.split('filename="')[1];
          const filename = contentDisposition
              ? contentDisposition.split('";')[0]
              : 'document.pdf';
          const data = await response.blob();
          download(data, filename, 'application/pdf');
          return { success: true };
        }
        return { success: false, responseData: response };
      })
      .catch(error => {
        return { success: false, error: error };
      });
  },
  getPetRationResults({ dispatch, commit, state }, payload) {
    return axiosInstance
      .get(`/ivs/Configurator/petRationResults?petId=${payload.petId}`)
      .then(response => {
        return response;
      })
      .catch(error => {
        return { success: false, error: error };
      });
  },
  savePetAdditionalData({ dispatch, commit, state }, payload) {
    return axiosInstance
      .post(`/ivs/Configurator/savePetAdditionalData`, payload)
      .then(response => {
        return response;
      })
      .catch(error => {
        return { success: false, error: error };
      });
  },
  savePetFiles({dispatch, commit, state}, payload) {
    return axiosInstance
        .post(`/ivs/Configurator/savePetFiles`, payload, {
          isNotJson: true
        })
        .then(response => {
          commit('setTempFiles', []);
          return response;
        })
        .catch(error => {
          return {success: false, error: error};
        });
  },
  deletePetFile({ dispatch, commit, state }, payload) {
    return axiosInstance
        .post(`/ivs/Configurator/deletePetFile`,  payload)
        .then(response => {
          return response;
        })
        .catch(error => {
          return { success: false, error: error };
        });
  },
  downloadPetFile({ dispatch, commit, state }, payload) {
    return axiosInstance.post(`/ivs/Configurator/downloadPetFile`, payload, {responseType: 'blob'})
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', payload.fileName);
          document.body.appendChild(link);
          link.click();

        }).catch(error => {
          return {success: false, error: error};
        });
  },
  deleteVetSupplement({ dispatch, commit, state }, supplementId) {
    return axiosInstance
      .post(`/ivs/Configurator/deleteVetSupplement`, { id: supplementId })
      .then(response => {
        commit('removeVetSupplements', supplementId);
        return response;
      })
      .catch(error => {
        return { success: false, error: error };
      });
  }
};
